import AdvancedFiltersModalView from './advanced_filters_modal_view';

export default AdvancedFiltersModalView.extend({
  bindings: {
    '.js-agency-checkbox': 'agency',
  },

  initialize(options) {
    AdvancedFiltersModalView.prototype.initialize.call(this, options);
    this.stickit();
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/agencies_modal_view.js